// @flow
import { BookUser, Globe } from 'lucide-react';
import { View, Text } from 'reshaped';

import type { Organization } from '@gandi/redux-organization';
import type { Organization as SharingOrganization } from '@gandi/redux-sharing';

import { Badge, Icon } from '@gandi/reshaped';
import { useTranslator } from '@gandi/translate';

import type { ListCustomer } from 'src/Cart/Customer/types';
import { useEntityType, useType } from 'src/hooks/useType';

import { ContactDecorationIcons } from './ContactDecorationIcons';

// TODO: Update @gandi/redux-organization
export type OrganizationDetail = {
  ...Organization,
  entity_type: 'organization' | 'user' | 'resellee',
  ancestors: Array<{ id: string, name: string }>,
};

type WithBlockFlags<T> = {
  isContactBlock?: boolean,
  isCustomerBlock?: boolean,
  ...T,
};

export type Props =
  // List organization
  | WithBlockFlags<Organization>
  // Organization detail
  | WithBlockFlags<OrganizationDetail>
  | WithBlockFlags<SharingOrganization>
  // List resellee
  | WithBlockFlags<ListCustomer>;

export function Contact(contact: Props): React.MixedElement | null {
  const { __ } = useTranslator();
  const displayedType = useType(contact.type);
  const displayedEntityType = useEntityType(contact.entity_type);

  const { name, corporate, reseller, entity_type: entityType } = contact;

  if (!name) return null;

  const svgsProps = { corporate, reseller };

  return (
    <View align="center" gap={contact.isContactBlock ? 3 : 4} direction="row">
      <Text weight="bold" variant="body-2">
        {name}
      </Text>
      <ContactDecorationIcons {...svgsProps} />

      {displayedType && (
        <Badge
          rounded
          attributes={{ style: { fontWeight: 'var(--rs-font-weight-medium)' } }}
        >
          {displayedType}
        </Badge>
      )}
      {contact.isCustomerBlock && (
        <Badge
          rounded
          attributes={{
            style: {
              backgroundColor: '#C3DDFD',
              fontWeight: 'var(--rs-font-weight-medium)',
            },
          }}
        >
          <View gap={1} direction="row" align="center">
            <Icon svg={entityType ? BookUser : Globe} size={3} />
            {displayedEntityType || __('Organization')}
          </View>
        </Badge>
      )}
    </View>
  );
}
